export default __webpack_public_path__ + "static/nagasakibiopark-ab8e2527a76bbfb71257e09d1f6beedc.jpg";